/**
 * Slider avec branding automatique pour les formulaires publics (référent + candidat)
 */
import { Slider } from '@/components/ui/slider';
import { useReferentBrandingColors } from '@/hooks/useReferentBrandingColors';
import { cn } from '@/lib/utils';
import * as React from 'react';

interface BrandingSettings {
  enabled: boolean;
  logo_url?: string;
  primary_color?: string;
}

interface BrandedSliderProps extends React.ComponentPropsWithoutRef<typeof Slider> {
  branding?: BrandingSettings | null;
}

export const BrandedSlider = ({ 
  branding, 
  className,
  style,
  ...props 
}: BrandedSliderProps) => {
  const colors = useReferentBrandingColors(branding);
  
  return (
    <Slider
      style={{
        '--slider-primary': colors.primary,
        ...style
      } as React.CSSProperties}
      className={cn(
        "w-full [&_[role=slider]]:border-[var(--slider-primary)] [&_.bg-primary]:bg-[var(--slider-primary)]",
        className
      )}
      {...props}
    />
  );
};